import { matchesCoordinatesProximity } from './geoUtils';

export const GEAR_WANTED_RADIUS_MILES = 25;
export const GEAR_WANTED_STALE_DAYS = 90;

export function pickRandomItems(items = [], count = 4) {
  const pool = [...items];
  for (let i = pool.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [pool[i], pool[j]] = [pool[j], pool[i]];
  }
  return pool.slice(0, count);
}

export function getWantedTripEndDate(post) {
  if (post?.endDate) return post.endDate;
  if (post?.startDate) return post.startDate;
  return null;
}

export function isWantedTripDatePassed(post, now = new Date()) {
  const tripEnd = getWantedTripEndDate(post);
  if (!tripEnd) return false;
  const endOfTripDay = new Date(`${tripEnd}T23:59:59`);
  return now > endOfTripDay;
}

export function isWantedPostActive(post, now = new Date()) {
  if (!post || post.status !== 'open') return false;
  return !isWantedTripDatePassed(post, now);
}

export function isWantedPostStale(post, now = new Date()) {
  if (!post || post.status !== 'open' || getWantedTripEndDate(post)) return false;
  const anchor = post.lastRenewedAt || post.createdAt;
  if (!anchor) return false;
  const staleAfter = new Date(anchor);
  staleAfter.setDate(staleAfter.getDate() + GEAR_WANTED_STALE_DAYS);
  return now > staleAfter;
}

export function filterWantedByProximity(posts = [], searchLat, searchLon, maxMiles = GEAR_WANTED_RADIUS_MILES) {
  if (searchLat == null || searchLon == null) return posts.filter(isWantedPostActive);
  return posts.filter((post) => {
    if (!isWantedPostActive(post)) return false;
    const lat = post.coordinates?.latitude;
    const lon = post.coordinates?.longitude;
    return matchesCoordinatesProximity(lat, lon, searchLat, searchLon, maxMiles);
  });
}

export function formatWantedLocationLabel(post) {
  if (post?.locationLabel) return post.locationLabel;
  if (typeof post?.location === 'string') return post.location;
  if (post?.location && typeof post.location === 'object') {
    return [post.location.city, post.location.state].filter(Boolean).join(', ');
  }
  return 'Location not set';
}